var _metadata, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBrakes = function SvgBrakes(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsdc: "http://creativecommons.org/ns#",
    xmlnsrdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnssvg: "http://www.w3.org/2000/svg",
    viewBox: "0 0 816 1056",
    height: 76,
    width: 76,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfabout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfresource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath18",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M 0,792 H 612 V 0 H 0 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1056)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath18)",
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(177.2573,310.0469)",
    id: "g20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22Type",
    style: {
      fill: "current",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 0.878,-1.259 1.324,-1.884 32.864,-46.152 86.8,-76.308 147.647,-76.308 99.881,0 181.141,81.259 181.141,181.141 0,99.882 -81.26,181.141 -181.141,181.141 -27.163,0 -52.949,-6.009 -76.097,-16.769 -0.762,-0.354 -1.521,-0.714 -2.278,-1.078 -0.826,-0.398 -2.469,-1.213 -2.469,-1.213 l -13.885,20.978 c 28.38,14.745 60.599,23.082 94.729,23.082 113.666,0 206.141,-92.474 206.141,-206.141 0,-113.667 -92.475,-206.141 -206.141,-206.141 -71.042,0 -133.805,36.123 -170.888,90.965 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(112.1729,305.5996)",
    id: "g24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fill: "current",
      stroke: "none"
    },
    d: "m 0,0 c -17.229,33.427 -26.353,70.712 -26.353,109.4 0,63.888 24.879,123.951 70.055,169.126 11.137,11.137 23.179,21.041 35.961,29.642 l 58.522,-81.34 C 99.413,202.096 73.647,158.7 73.647,109.4 c 0,-24.44 6.332,-47.429 17.442,-67.413 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(303.0977,502.6567)",
    id: "g28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path30",
    style: {
      fill: "current",
      stroke: "none"
    },
    d: "m 0,0 c -9.941,0 -18,-8.059 -18,-18 0,-9.941 8.059,-18 18,-18 9.94,0 18,8.059 18,18 C 18,-8.059 9.94,0 0,0 m -54.098,-73.657 c -9.941,0 -18,-8.059 -18,-18 0,-9.941 8.059,-18 18,-18 9.941,0 18,8.059 18,18 0,9.941 -8.059,18 -18,18 m 54.872,-71.492 c -9.941,0 -18,-8.059 -18,-18 0,-9.941 8.059,-18 18,-18 9.941,0 18,8.059 18,18 0,9.941 -8.059,18 -18,18 m 79.425,24.875 c -9.941,0 -18,-8.059 -18,-18 0,-9.941 8.059,-18 18,-18 9.941,0 18,8.059 18,18 0,9.941 -8.059,18 -18,18 m 0.703,99.033 c -9.941,0 -18,-8.059 -18,-18 0,-9.941 8.059,-18 18,-18 9.942,0 18,8.059 18,18 0,9.941 -8.058,18 -18,18 m -59,-27.568 c -22.091,0 -40,-17.908 -40,-40 0,-22.091 17.909,-40 40,-40 22.092,0 40,17.909 40,40 0,22.092 -17.908,40 -40,40 m 113,-38.848 c 0,-62.408 -50.591,-113 -113,-113 -62.408,0 -113,50.592 -113,113 0,62.408 50.592,113 113,113 62.409,0 113,-50.592 113,-113"
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBrakes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/brakes.2ee6fe7e.svg";
export { ForwardRef as ReactComponent };